"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TagGroup: function() {
        return _index.TagGroup;
    },
    renderTagGroup_unstable: function() {
        return _index.renderTagGroup_unstable;
    },
    tagGroupClassNames: function() {
        return _index.tagGroupClassNames;
    },
    useTagGroupContextValues_unstable: function() {
        return _index.useTagGroupContextValues_unstable;
    },
    useTagGroupStyles_unstable: function() {
        return _index.useTagGroupStyles_unstable;
    },
    useTagGroup_unstable: function() {
        return _index.useTagGroup_unstable;
    }
});
const _index = require("./components/TagGroup/index");
